module.exports = __webpack_public_path__ + "static/media/BS.05bdb5cb.png";